<template lang="pug">
header#v-header: .container
  a(href='https://buzzorange.com/techorange/', target='_blank')
    img(src='@/assets/to-logo.png', alt='TechOrange 科技報橘', :width='$store.state.mobile ? "100" : "168"')
  nav(v-if='!$store.state.mobile')
    a(@click.prevent='$scrollTo("#about", { offset: -$store.state.scroll.offset })', :class='{active: $store.state.scroll.position === "#about"}', href='#about') 關於特展
    a(@click.prevent='$scrollTo("#topics", { offset: -$store.state.scroll.offset })', :class='{active: $store.state.scroll.position === "#topics"}', href='#topics') 文章報導
    a(@click.prevent='$scrollTo("#review", { offset: -$store.state.scroll.offset })', :class='{active: $store.state.scroll.position === "#review"}', href='#review') 現場回顧
</template>

<script>
export default {
  name: 'Header',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'
#v-header
  +position(fixed, 0, 0, null, 0)
  +flex(null, center)
  background-color: #222937
  height: 70px
  z-index: 99
.container
  +flex(space-between, center)
nav
  a
    +font(18px, white, null, 1.25px, 500)
    text-decoration: none
    transition: color .2s
    &:not(:last-child)
      margin-right: 35px
    &.active
      color: #FFA029
.icon
  cursor: pointer

@media (max-width: 1023px)
  #v-header
    height: 50px
    position: relative
</style>
